import { styled } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { MenuInfoButton } from './MenuInfoButton';
import RedeemIcon from '@mui/icons-material/Redeem';
import { Image } from 'lib/Image';

// Remove this flag when the menu awards button is ready for prod
export const SHOW_MENU_AWARDS_BUTTON = false;

interface MenuAwardsButtonProps {
    onClick: () => void;
    isDesktop?: boolean;
}

const StyledImage = styled(Image)(({ theme }) => ({
    height: '100%',
    width: 'auto',
    marginLeft: theme.spacing(1)
}));

export const MenuAwardsButton: React.FC<MenuAwardsButtonProps> = ({ onClick, isDesktop }) => {
    const { t } = useTranslation();
    const { merchantId } = useParams();
    const [showDefault, setShowDefault] = React.useState<boolean>();
    const awardsIcon = React.useMemo(
        () => `${process.env.MEDIA_URL}/tenants/${merchantId}/app_assets/menu_awards_cta_icon`,
        [merchantId]
    );
    const handleError = React.useCallback(() => {
        setShowDefault(true);
    }, []);
    return (
        <MenuInfoButton desktop={!!isDesktop} onClick={onClick} variant="outlined">
            {t('MENU_AWARDS_BUTTON')}
            {!showDefault && <StyledImage src={awardsIcon} onError={handleError} />}
            {showDefault && <RedeemIcon />}
        </MenuInfoButton>
    );
};
